// This file is automatically @generated by scripts/generate-json-schema/index.ts

export const sessionStorageVersions: { readonly [key: string]: string } = {
  abnDetails: 'd2918298591f60dbae01094e5be99ae3',
  academyCourses: 'daa590ef35214f5e040f2bd6ee34412a',
  academyInstructors: '6f4a29e8301b4de6ba957be8a227331b',
  academyPriceTiers: '8f9b15b484a31e0d60ea7001b3c61961',
  accountProgress: '5154e12aa4310f76ada20683336603e7',
  activeLanguages: '115ba8046cd83175ff9789c9a5da0de0',
  adminChallenges: '8d8bb7b460f48d558183d0451c11a4a0',
  adminChargeUserFee: '36396f08c9455c1e4ba34ad5b5bc8195',
  adminEnterprises: '3dfdaccceebde8172b816649d9cd7d32',
  adminExternalCredentialAllocationLogs: 'cb3fa29ebf1cd8f89b0931069f03a161',
  adminExternalCredentialAllocations: '1f3badba539c90ad579b7a6b203e9e4e',
  adminExternalCredentialProviders: 'c2bb040d6050edecff883fd45ad37f42',
  adminIrisOffsiting: '66087bac4f22a26a0dd2b0aba99ca394',
  adminPcbBanManagement: '5e22eb3dfa06e97201b594d857b294a2',
  adminPools: 'ddd4c94ffa5deb216310520d974a90c9',
  adminProfileHistory: '9c1e0d5ed971937a29c87a6637fbec71',
  adminProjectDescriptionUpdate: '80ee25c3b348b35337a81bdc97c2086c',
  adminUserDocumentSubmissions: '97cedc32f5ecee6a95749058a9792fd2',
  adminUserEnterprises: '1cc08fb4667b5ab1271bb25872c03af1',
  adminUserPools: '1348e6e46173a87cc6d1978af799b063',
  adminUserVerificationProcesses: 'de8899ab8e43f96933ad883092799337',
  adminVerificationProcessTypes: '2c775d17e3c24746c1f1cac290962d7a',
  agentSessions: 'f31159563144eda9ef33b0648316bb45',
  agents: 'e6cb74b344e1af4effb5bf390a2a2694',
  aiChangeTone: 'b10ea52adc3406735390f54b1de2ba1f',
  aiConsultantAudio: 'fd2e5f9c28d01c02963ef5e2d395416b',
  aiConsultantChatTranscript: 'c25810c29ff5899a370f03b459e3fb21',
  aiConsultant: '68129d3a99c978e93c3873a94a5dffde',
  aiContinueWriting: '72eddfe20506cdfe241e2212ddfbec3b',
  aiConversationStarter: '04ae269f264bfba6e1dc079cc4121223',
  aiFunctionCallHistory: '1874d9e1b02d8770bab1ca80f7ca27b7',
  aiImproveWriting: '72eddfe20506cdfe241e2212ddfbec3b',
  aiPlayground: '075d1ea4bc38e6e015142b209f42e4bb',
  aiPromptBuilders: 'fa084dd4b809f7282417d63266628983',
  aiPromptPreview: '7f3b7dfd6e10ca7cea11ada9cefc814e',
  aiPrompts: 'b1200d8c4b9627a329107ee2b386ad51',
  aiProofread: 'cc9218713cf763e01ecc72558f940b49',
  aiRequest: 'fc889c72bb7bb2e1c88f0c535ad1613d',
  aiSmartCanvasMakeReal: '9737b97432432824572fa7690e1da526',
  aiSupportTypeModelConfiguration: 'd9c3a2053dd21e6ee62edf8b347ce0d2',
  aiTaskFunctionDescriptions: 'e771e1ad3bd0efbfd235a14b5562dd9a',
  aiTaskModelConfiguration: '62a8c08872f1c48cc8370fbb060084a1',
  allProjects: 'd8e7a3e6065b6b4658204b460cea7ab0',
  analytics: 'fd6e29bae50560212ae0060acc8f2c94',
  appInstallTracking: '66aae0351017216c38af468e985ee34b',
  applicationScopes: '9947a1a7d3aef85aebd2999eac5c31b8',
  articles: 'bc68b96aa4d4eb562bb19ef23cc8d2f6',
  banners: '5837f7756ceeaa9d1284e3f0440992e3',
  bidAwardDrafts: '50c0232ef03e2840309f6747df5e8044',
  bidAwardRevokeReasons: '64acf7c4c868f9dbcb96f165f6152f33',
  bidBuyerProjectFees: '1fe413c25bf07f0f2c6c9a525a43b20d',
  bidDescription: '97de045865291ad18b5dec4449c82cbe',
  bidEditRequests: '3adb4df25e6f2abbe24ddd9c4782d4a4',
  bidPitch: 'f38640454a19287e90d35a550db33dec',
  bidRestrictions: '775a0265b53402c876498914226a6280',
  bidScores: 'abf7389f299ca35ca24fca88c223b2d4',
  bidSummaries: '7d5ace0b55b64e31fa94713422e25ab0',
  bidUpgradeFees: '4579a27fe5872b4df1b9cf24f9c53d57',
  bids: '07e4f6ecbcb7ff3afa583554e3b1ee55',
  billingAgreements: 'd12337c7d08081e41204713006b4de1c',
  blastChat: '1b32f295e25bf3ab097cfea34fc652c7',
  businessBuilderAttempt: '02bc267d21c6a060882726111364ba96',
  campaigns: 'e9b8b0accb91cf9eb0f204cb95ffd0be',
  canViewEmployerProfile: 'e4cd062351bbdf3e5ac60870fc756d88',
  canvas: '8f3e9702d1d06938cda15c3bd27dccc4',
  cartApprovals: '144b1843c9c5213201fe9238928f6d78',
  cartItems: '04436d5c00e0f6a27645c9e004d39725',
  carts: '15319b760009c0c9232da95866caa41c',
  categoryPageContent: '6735adbf5cff37e855b1056ebf374d8f',
  categoryPageViewUsers: '24718ab958f2f66e39b89ae3ae284494',
  certifications: '43fd8862311f73a91a22f2e897799065',
  challenges: '8d8bb7b460f48d558183d0451c11a4a0',
  checkInSchedule: '996cc1427b53509784811c9de2a64eaf',
  commentFeeds: '5beeaaaafa2fb4a8506ee5f013e2c632',
  comments: '90997e7b2a9d0ffd77f87e14df17d91f',
  contactUs: '24e8637011e12e4aabc0e56351fed688',
  contacts: 'ea0263f70a017cbbd7f8171ca317cfe3',
  contentCustomization: '724b0856bf76e9bb4462cbee64354a1b',
  contestBudgetRanges: '68ec769e2457359239fdcc61ad36f041',
  contestCollaborations: 'dbe3b1d3eb3e6c8749f8c876ed9a0606',
  contestComments: 'f7c0d794e15afbe67510057bab896401',
  contestEngagement: 'a5593474fb4fe13cf7ff54a2b5dcacda',
  contestEntries: '35abb2fc97c56905d8e8171d23260c73',
  contestEntryMessages: '3f5ab3f4442354978c342be027847446',
  contestEntryOffers: '4b2413d572e0f8f8b616258e6ac8cc22',
  contestFees: '3f4d22a8c03fcb58bb55b5d361dc07b4',
  contestFiles: 'a6232d99e4264ffb391fb999eb3867fc',
  contestHandoverFiles: 'ae040dc5675a1456a73d419243d287b0',
  contestHandovers: 'db7f9b66fbcb55732b8f92523910fdc7',
  contestHasInvoices: 'da0535723aa640de1eae01ebdd336341',
  contestInterestedFreelancers: '3fdb8a1653a2b93d78afeb2679590b3e',
  contestInterestedUsers: '24b5fb96b0f09d45a2fb190fb92892d3',
  contestInvite: 'f06aea98eeae00234f7e734b108ba73c',
  contestMessages: '065919599825ded694989467bb2b7ad3',
  contestMinimumBudgetClassifications: '5927f1833074f51a601116d91011d5e1',
  contestPolls: 'd6f47e4b8b7db7c84efa7e82ce0a5b70',
  contestPrizeDetails: '76b6865ac39718712f8f3306206708b4',
  contestQuickviewEntries: '87170de12e60b2099c4a184920e215ea',
  contestRubricSubmissions: '7cc35149f4da347798ebf365c77740a9',
  contestRubrics: 'd88b55b6d86877e1c21340e46ee86361',
  contestUserHasGivenFeedback: 'b5a67d52ff7cbd65f749102fd8abeec6',
  contestViewContests: 'c55ade23bf82e4b294fc47cd5c09cc1a',
  contestViewEntries: '62342a9c8e6b5a6a8433530398de1809',
  contestViewEntryIds: '2fedeb6f70be9f3d87b96332ca7eb583',
  contestViewNewOrUpdatedEntries: '62b044801e8c0866983e8371ee004aef',
  contestsInterestedIn: '0782237f0759504816d475e51da60469',
  contestsSelfInsights: '6d4a26f1f9e583f35f315779173b83c0',
  contests: '63b4cd78db54dbe35c713fa71e14df13',
  contractDownloadUrls: '1e828b4d3ad8228d31bf74d54f48bd87',
  contractSigningUrls: '175a25c4e9baf9e3e8e823304af7d2fb',
  contracts: '274a28bcdd46b02b47cfda088ab6eabe',
  copilotChat: '27afff462ec51c895698155cf091c8fa',
  copilotEnquiries: '0278ee17d465de99d4f836ad94481f40',
  countries: '9f89d95c0638cfde05c972f3350a4a62',
  countryStates: '201562b40ea0477612bae359ea10a511',
  currenciesIncludingExternal: '7de9b2df5bf61db45209b0276ae15363',
  currencies: '7de9b2df5bf61db45209b0276ae15363',
  currencyDetect: '7de9b2df5bf61db45209b0276ae15363',
  customBanners: 'da16e6beda9d8a6f8bde40afb1c2c1f3',
  customFieldInfoConfigurations: 'bbff3816f6a3095ed7b6d62fd6753948',
  customFieldRelationships: '760f934980f29120c1c1cf00b61fac50',
  customFieldValidations: 'b8695c250448d24c001f702331656e89',
  dashboardPolls: 'df15b765ec84e9410c25465c4d65ef9a',
  dashboardWidgets: '1b5a699c2fa5a9c1be3a437be2a1a1c9',
  deleteCommentsByUser: 'c53029cea66b4cb7ba1ef834d051b62e',
  deleteFeedsByUser: 'fe08de48fc4c47412f7a11a67cd740ab',
  deliveryContactsSensitiveDetails: '7808941434956b2bc798930298152445',
  deloitteSubscriberEmails: '2a956b3ce9896b790432b92033dcee4b',
  deloitteUserInfo: '6f940769d6f4aad061a8ffae7ad86b63',
  depositFees: '329d2bf37512cab70fcf4f6195f6dcc1',
  depositPageVars: 'c9655864eb24e15da79401468c30f148',
  developerApplications: '937e94bb45e2b2d0c548490d1e4237a9',
  developerTokens: 'ae77f04e1068b8e15782e70604eceda3',
  discoverCollectionItemSaveCount: '46ee687e17846ba643a20026586716bc',
  discoverCollectionItems: 'c831f02ea3285e711442de3ff12fadf5',
  discoverCollections: '299e0f1dddafa5fb523fe3f6b95d26f2',
  domains: 'c0e06272e05d594cf6702b5419ed5243',
  driveFilePermissions: 'c0cff6c7d2029832d4642533a723540d',
  driveFiles: '35b7f881fba5ea2784e30179c94622c8',
  educations: '8e7f7e3d902633deb708d813bb61e9dc',
  emailLeadCapture: '7df8449a7c15a826e66557f13af0f4ee',
  employerReputationsRehireRates: '5fc9a744d2ba688513624a7529f6475e',
  encodedUrl: '44db17c46c57d7831b9e560e1613b31e',
  enterpriseBillingAgreementsBalance: '388804f8cb93db4aa1acfb33a03d7c72',
  enterpriseContact: '2635f12400d7e3d3ed35891422e13365',
  enterpriseLoadshiftAssetFinanceQuote: 'd0eecd52beae7a8f6c46bcdb13110177',
  enterpriseLoadshiftCancelGrandfatheredMembership:
    '8bf8f74068ccb1adc336b38cee4546e9',
  enterprises: '62aaf5c23e5f6081a98a7471b8e15e3e',
  entryRestrictions: '855554ddce05a2720b8db87b16ed51c9',
  equipmentGroup: '4a0f9784c610532ed7be41695545121b',
  equipment: '401a6e037ec2892bf5110d5e3795d3a8',
  exams: 'a490e8e606bf16f4f0f200c31d54e47f',
  exchangeRates: 'e3eddbf66ac9e18a5e4319e8a12f34ac',
  experiences: '1b1114cbdd5711150673e04d8c0cc958',
  externalContactStatus: '47f540b69d040c48d14b124796efba93',
  externalReference: '5a6fbe55bbb93a123f848ec87617780b',
  feedMeta: '5d219e63f1e8ab6a7a1df92c03b5b58d',
  feedPosts: '09a1e809fd3b24a2d096f6a0b8a92aaa',
  feed: '2d32805b5f06adc548650e581b2a5398',
  feedback: '992692453e8a744e215e402b7464575c',
  fieldServicesTalent: '6812eafadad1e4e3692a188745ae2e41',
  financialReportingRecord: 'b266e0fc972d07f3e995825a489044d1',
  findPageDetails: '0aae1d241f180ee5989c3fc36ebd7a88',
  flareActionMap: '5ffe0c01f376495db49d429aa45b8c7c',
  flareActions: '32d3fd4b7780031c501f7694448999bc',
  flareAdminLogs: '81701bfe369d51c6ad6f213d032eb90f',
  flareCheckpoints: '6a1f2291baae816bc458877ff4d26bc3',
  flareRules: '25d46d18ca591e50c0c2a329786ca3d9',
  flareRulesets: 'ec8997202700db72c0c713233cb551b7',
  freeRecruiterUpgrade: '97f72ba05979e6f39e7d22c3d36eda36',
  freelancerReputationsRehireRates: '123c7d88ba788431b747cfafa75a0a35',
  freelancerReputations: '5f86ecc9f74339e90bbef7e3e9b8b76b',
  globalFleetContact: 'bf1cb95f2ffd3b77a09962f62f2ffeab',
  grants: 'cf1980d9a2c98d99478796f3cea89eaf',
  groupActions: '19fec4d55eabda7f893205ffd0daee59',
  groupAttachments: '44db5335e07d07a1c336502beda3d479',
  groupFeed: 'cdba77928db369484a91be926766654e',
  groupMembers: 'f6ce733b4e71fb174ec345732b40be2e',
  groupPermissions: 'f74fa869aebb39ea8facbd8688f872c7',
  groupsSelf: '1d3b42f3bc3e780532ae98faaf99c15f',
  groups: '1d3b42f3bc3e780532ae98faaf99c15f',
  guidelines: '68e44b5a32841d668d1e92fc8360a722',
  harvardContacts: 'ccb97e3799d37a708417df8bc7cc3b83',
  hirePageDetails: 'dca83f4625f0b09920a915f7f9898e37',
  hiremeCounteroffers: '01f09946ca292605b754886da54f72cf',
  hourlyContracts: '81b362465ff0f0e19ee711f118ac5791',
  hourlyProjectMilestoneFees: '06d688f2a842f625af0fb0e8fa3c9b30',
  insightsBids: '276a49cd9bd766cd5a252ee5d337069c',
  invitationBlocks: 'f39249fed15e35b485b73ef1623f1686',
  invitations: '157f0ae01d9c5531e29b4b1f83fdba87',
  invoices: '11248bfaa18fee68d253cba4ed83bb43',
  ipContracts: 'b4a6b468834bdbcf9db8cb825d8913f2',
  isFreeBids: '345c84fc70f69985df5d0eee6668f217',
  isLookingForWork: 'c90fd79bdd9648b0dcd3fc7c80d05651',
  issuingInstitution: '191c5080a6cbb19009eb2935e758f46b',
  jobClassifier: '8d0cb74f449a0a11931133e83a9ad446',
  languageDetect: '8396cfb5cbcb3c8df3a922741007716c',
  languages: 'b5e1f3de9dae5b4c1526d475397a9bcd',
  loadPriceEstimate: 'db71537979f183a4d91825545eda9e8d',
  loadshiftSiteStats: 'b453cc6f9ed19786dd75b90cf3079d5b',
  loginDevices: 'e1e8c7458dffdb0e840e9ca6e55283b8',
  manageViewContestHandovers: '68ed731cb3f1e6a3689fd6f95224931d',
  manageViewContests: '73658c1dcba604e25a0fcf0898143e55',
  manageViewHandovers: 'ec97c2ad8ef331b00061b65d0ca3fcb6',
  manageViewOngoingBids: '12f9cfe0cf7cf4a60dc8b94aa90e1f50',
  manageViewOngoingProjects: '2155764961ee104bcdc7063832bfd80b',
  manageViewOpenBids: '972809a1c4e167e8d1e4ee36604d7ad7',
  manageViewOpenProjects: 'a3d09a0e28f9a2357159b20662dcb7ec',
  manageViewPastBids: '3ddb0415a8a2d91995270bffc69a50d6',
  manageViewPastProjects: 'a2715b3ff61601d6ee40ec3a7b5d86ee',
  marketingMobileNumber: '6d57111b5240989328fd6d7825247fe3',
  membershipBenefits: '1b3935953dfa7f6cad67f08a5e93380a',
  membershipDowngrades: '50b9485c910e81d92e1401e3ad1e5886',
  membershipPackagePrices: 'fa6e18fcf9dbc6654c1be4b8e3085d28',
  membershipPackages: '0593136eebe94e9ad4ebcdf6445e72e3',
  membershipRenewals: 'e357585dfa2f66ce9a1f79858a85bd95',
  membershipSale: '55fbeb62a6e565505a75dc3f9976634c',
  membershipSubscriptionHistory: 'cc453171cfe1fbe99a7e7d4bdc2089bd',
  membershipSubscription: 'e857bce84db7cabcdd1541e8b59d4c49',
  membershipTrials: 'ff61d0616faa339d81168e379fc03f70',
  messageAttachments: 'c3f3b324e96a4dc0ecb0fa662b05da53',
  messages: '081235ab0ae7a184403e120042ade009',
  milestoneDrafts: 'f11b88854b984bd391b567b18c3af8ed',
  milestoneRequests: '25ca5404752b5fbd9dc2eab8759b56d4',
  milestones: '9887b808db0f32a8c8e1c620814bcba3',
  modifyBidSellerFees: '403c3613ac89c1de9cf84c3c7455df3e',
  mygigsExpressionOfInterest: '91301a124c27f055daa04eae6179c50d',
  nativeExchangeRates: 'e3eddbf66ac9e18a5e4319e8a12f34ac',
  nearbyProjects: '7a4cca4f53eeccabb0aea8253192860d',
  newsfeed: 'fbf6146ea73aab0fc29b97e339ff89cd',
  nextPreviousUsers: '84ead1aaa99dc711b4f7027f20a4ffc2',
  nextProjectRecommendations: '3cc469a543cf097dd847b550a4d0112a',
  notificationSettings: 'f9f8604714c8832b680f2bbaff2b56bf',
  notificationsPreferences: '707e41567df79de7d3093d607f53368a',
  notifications: 'a1a6e6bcdeff2d42779e8279d4681d00',
  onBehalfProjects: 'a2f16cd31ca8fbf3434849a6e48715ff',
  onboardingEmailChange: '913ea9a2ada6c4fa14696c170cf6a9d0',
  onlineOffline: 'c8e6e68cd993759dac49382b61a1ac64',
  openGraphDetails: 'b6ab3861eee0427fca4cf3520ef15abd',
  operatingAreas: '6315564555c3b367c2d274b2be650453',
  partialSearchArticles: '00f64d056c0021d48cd96715bb3c186c',
  paymentShareInterests: '2dfbb50654bee0dfbfefdf174c53b594',
  paymentShareMembersSpendingDetails: '44105cc7ca131d371d85b9cda7435592',
  paymentShareMembersSpentAmount: '3464028ae93ed58778bd508875f70997',
  paymentShareMembers: 'df27633826da5d3e3026a0fad7e70358',
  paymentShareTeams: '57dee1eed046d2ae0f717cede0d71d73',
  paymentShareWhitelistItems: '21b6c79935ff7da502a41309b33e4fd4',
  payoutAccountForm: '0f23629cc18d23b2624400d1fe1f73cc',
  payoutAccounts: '44eccf32823e257a3cbc88434132f4a5',
  payoutContext: 'faeba93132cbba8d18a94f900eca3abd',
  payoutLimitExemptions: '3d274d832b852dc6acc98f06eb63002d',
  payoutMethods: '92f2004d858af89162952db738135e26',
  pfSupportTickets: '1c736a0679b47a2f92fee2888149c236',
  pfpSkills: 'c385d285d53b8bf4d40fcaedf8affbb0',
  pfpStatus: '4f2c9e4711e1703f733844833d2476a2',
  pjpAssistantEnqueue: '9d60ace685ca5972b1967be2059d8bcc',
  pools: '3b94a7749b10d8dd0ffb088d2f5c56c8',
  portfolioItemsPositions: 'c90c65d937ea8976d21e56a613854985',
  portfolios: 'b002fc4d699a2bcc1c5f9f10da0d7971',
  postFiles: 'f226d954dbdecb6da37be039cbfd512d',
  postJobPageDescription: 'fb38afe2bf8eae2d37d5272d68d41e2b',
  postJobPageFormState: '4ba6ff151d0b8eea2c91b36d92a37a56',
  postJobPageQuestions: 'fad548e395d9018769ccb2fa81ca35d2',
  predefinedDiscoverCollections: '299e0f1dddafa5fb523fe3f6b95d26f2',
  predictedSkills: '724d5f18f98df47a7253837e1d03c9a6',
  preferredBillingAgreements: '438c0314e38978530e0e69364695b6d7',
  preferredSupportAgent: '21f042f246278525c8c179a996acccb1',
  profileCategories: '269dfb39b5b6c3a6ec54544a4246e759',
  profileViewUsers: 'b7d976719fb628174a65f491d1e0c5af',
  profiles: '6661b29a1cf90765ecd2b4923199f8d1',
  projectBidInfo: '3c4a0db0dd012c7cbab6ab3a14b6d425',
  projectBidStats: '9d4f1055944045be16cdaa37df0c0ba6',
  projectBookmarks: '94b358c99f7d89310f719640a163581c',
  projectBudgetOptions: 'fe3aa365c616fb43e1da48afcc2f130d',
  projectCollaborations: '7fee7f1d7ebd65b430377918a42ce486',
  projectContestClassification: '56010c1a3e786c1b757646cb54a5778c',
  projectDescriptionEntropyCompletion: 'fa666aaab87234a9f0d6bdb5e5247a5e',
  projectDescriptionEntropyQuestion: '08f4e34c57a1417c7c76e517a78d969c',
  projectDescriptionInsertions: 'e4e5dec18739083995898004453127c6',
  projectFeeInfo: '141ae845bb7bcbec6f8b1c39d825b7f2',
  projectFeedFailingContests: '88bc99dddd8b43cb90c6fef5d85e55ae',
  projectFeedFailingProjects: '88bc99dddd8b43cb90c6fef5d85e55ae',
  projectFeed: '88bc99dddd8b43cb90c6fef5d85e55ae',
  projectGroups: 'c11f55395fee67f29936fde8ebd50214',
  projectInvite: 'd88f62eaadcb2ebd35a51e815efbf160',
  projectMatchInsights: 'ecabc86a74f7fdd6002e9ed5a6d86276',
  projectOffer: '7f26ad3000909c270de718570960cc58',
  projectQualityDetails: 'e5dec7981b77b82b0dafc18d7a37774b',
  projectSkillsPrediction: 'b90cd66f3fbecf8524251b1e46d1f516',
  projectSpamControls: 'd6a17d28a2a784e04e545ff3802dc6ff',
  projectStats: 'd3233413cbe6fca69a15a487c7a3b751',
  projectTitleEditRequest: 'dc4b523352a59b92007eb6a8beda687f',
  projectUpgradeFees: '0dfb153e40e347289a9e291d129716c4',
  projectViewBidderLocations: '9db55fdb5d51bc1d919339280a23e06a',
  projectViewBids: 'c4c16b9ca73c3f184c28eb1768904b52',
  projectViewProjects: '7f3e443afc6c137ae5f87c3c0a82c463',
  projectViewUsers: 'babbb5b2fa8f7ad8a67aeeac9b1d3d09',
  projectWorkspaceLink: '870fc3501d7970d44e37241260b66519',
  projectsSelfInsights: '811ba7045bc5d3f1c9f6e70e58f0dfe3',
  projectsSeo: 'e8e5c8002a047dde889698ea9585bbb6',
  projects: '772c892c34af49fb0e5781964c6a3a22',
  prototyperPermissions: '8694e9c9b92649980424a7cb20f96ebc',
  publications: '32798a1bbd15853ddb6ec4f76fa43f97',
  quotationFundRequests: '4a0bc7d5c9e16816b1a2807cda19af7d',
  quotationFunds: '9de2e842f1c177afcdbc2a7cc0be74e0',
  quotationItemRevisions: '4c6abe828d31a90ed340e51162ff0be6',
  quotationLogos: '2912f2c3e8f58b953986359c26789d34',
  quotationRevisions: '795a13e80526359b40bc15f67a845370',
  quotationWhitelist: 'd5b9567e6615b0cfcfadf90db47c643c',
  reactionsTypeCount: 'c8e2bc130bdfa81a8d6688a5cfeb3b71',
  realtimeMultimodalPjpReviewStepChat: 'afcc63eb85fbb94591a846156861cf82',
  recentSavedSearchAlerts: '937bc55ddbcb405f091fd068189eb307',
  recommendedMembership: '136b2dc1686addd12e396cc73176828a',
  recommendedUpgrade: 'f8d027a7f45c8d7b8234589b6fe3f227',
  recommendedUsernames: '0f00ae1f52e22a2b68a9f5e4abee3100',
  recruiterOptOut: 'f7106ebbf3e60c1a6fa980bcf70ae004',
  recurringBillingInformation: '0a0dc30ec2a38a37678e6be97a06dea8',
  referralEligibility: '400612acf11df06a1d34a1725b6a5fbe',
  referralInvitationCheck: '24eddef86909e002dd9ee8cded56f8d2',
  referralInvitations: '61348e34ac68a8f8c437f8d0f33eddf9',
  referralRecords: '84f26f553de5c4f2608af69fcc35b092',
  referralToken: '5c8adf6f78112fb9e94f52bf06a46532',
  retellPhoneCall: '0c7e89ff1e84a357bce7d2d85d340be7',
  retellProjectDetails: '365467904f540f38c0ef39fdc4b87207',
  retellToken: '6e395c1857451f42833bc32d0e1d32eb',
  reviewsSkills: '3ed5c1a7ee988dfeed7aceb5641ffebe',
  reviews: 'dee4108c5f08b79d817801a41d3a78da',
  salesTax: '48b3aad4850275c7e718b9015e58561c',
  savedSearchContexts: '932deb120ebf7c09ac608cd3f25c289c',
  scheduledSubscriptionPayments: '349093bfadf0459e890927f844ae223a',
  searchActiveContests: 'b0d16b4263eefa6376c1c4d5b03ed46e',
  searchActiveLoads: '3064d1e5dc883ec6f82d727e804c1668',
  searchActiveProjects: 'e956a1260706ae7a43257667b71ca41a',
  searchAllProjects: '772c892c34af49fb0e5781964c6a3a22',
  searchArticles: '08fa95c0fd6774fcae027ccbf4f9e291',
  searchClosedContests: 'b0d16b4263eefa6376c1c4d5b03ed46e',
  searchContestEntrants: '16c81d21c56d0f1b5ec1929be770feae',
  searchContestEntries: '62342a9c8e6b5a6a8433530398de1809',
  searchFreelancers: '59790ae02045d1b1a8fcd4eb0284fd9d',
  searchKeywordProjects: '1f5af6a224fb12cd6c5bebf038916efe',
  searchLocalFreelancers: 'a590d229c06f5b3b64312de1c32574f8',
  searchMyContacts: 'e62414e4cf126c78a96d0bd3b10ac132',
  searchPreferredFreelancers: '2ff20967c711e012aebd1764c6f8768a',
  searchProjectsSelf: 'e3cf76608cb456162809f92b333928f5',
  searchSavedFilters: '2c7ce484d71123ef3e14568d6f81aba1',
  searchThreads: '120caa646814f9f54d979daeed0a34ef',
  searchUsers: 'f69938a24298d79a41ca4cc7c3b4d954',
  securityPhoneRequests: '524c1ee68465953f496b8cf1450d8bd6',
  semDynamicPageContent: '9f595bbcb56e0aee9b4d889c486a37b4',
  seoNavbar: '8e5b1dfa322833dc975cdeee75bbb014',
  serviceOfferingAttachments: 'fd5c0dc64756a887e5bb67c76a8f78b7',
  serviceOfferingBuyerHistories: 'a2e65d6732e073a86bad449ca3bcd47c',
  serviceOfferingShopCategories: 'a178d6fac700b57d027ed6c25f483191',
  serviceOfferingShopCategoryServices: 'cff5d149d754689c4bc8911e3ab84ed2',
  serviceOfferingShops: '9ffe1d9e2b9eabd14a7d3fa5726761bf',
  serviceOfferingsWithOwnerDetails: 'a9176a49661a329d3908fe123576e0e0',
  serviceOfferings: '0c1c4c554236bd1abe78e0a1ded1860b',
  sessionResolveReasons: '374dcf773bbcb86ec7ed10f819090997',
  setPreferredFreelancersOnly: '0ff185bb3d8b14a690b87ff2b8b0e67c',
  showcaseSource: 'e9d95438f258ffe530b4e2ef139e30ae',
  showcase: '2015e193cf66a69c3c40c06f2d64389b',
  similarFreelancers: 'a94c2497773696df7c26be74e2ff7530',
  similarShowcases: 'a94c2497773696df7c26be74e2ff7530',
  siteStats: '95a8af1926677fb0ed9b8a1de744dd5d',
  skillBundles: 'd00f17bc6add44c135e16d1641a0d65f',
  skillsSubNavigation: 'b53931bf59b48506b398c94c42f675a7',
  skills: '3025b28c255b7b6b130b83939b50baf0',
  slaTasks: '442b21e31211db773bb2b7c55534019b',
  subscriptionItems: 'a2db7875097ae701b02602277cde8770',
  suggestedSkills: '3b1aa909ddbd7e9a21668e20c78a2271',
  superuserAgentSessions: 'f31159563144eda9ef33b0648316bb45',
  superuserBids: '07e4f6ecbcb7ff3afa583554e3b1ee55',
  superuserGrants: 'cf1980d9a2c98d99478796f3cea89eaf',
  superuserGroupMembers: '600efb0e333c1d696c82de77cab69374',
  superuserGroupPermissions: '9abb162bc6a3c0f3f2bf4bc9c02a1ecc',
  superuserGroups: '1d3b42f3bc3e780532ae98faaf99c15f',
  superuserMessages: '081235ab0ae7a184403e120042ade009',
  superuserMilestones: '9887b808db0f32a8c8e1c620814bcba3',
  superuserProjectCollaborations: '7fee7f1d7ebd65b430377918a42ce486',
  superuserProjectNotes: 'c3e863437fda2a6c41660d9f8986675e',
  superuserProjectViewAllProjects: '9edbad001b329b6239c4b4135af8b0be',
  superuserProjectViewProjects: 'a4b60768c0b175a8d079842e65f2f372',
  superuserProjectViewUsers: '6ae6a069ee79951f9533e640c4283a9c',
  superuserRoles: 'dfdb0daa6011b44b684b59e824473ba1',
  superuserSearchThreads: '3110894a8bbe0c2e68f2740f4b97bf34',
  superuserTaskGroupSections: '4f685d834c91aa4b2eebe5403d1287f6',
  superuserTaskGroups: '271f3eb3faaaf1da2a4df73f58a8c333',
  superuserTasks: '7282fe9f544b44f575a2a5e1c44e03d9',
  superuserThreads: '3110894a8bbe0c2e68f2740f4b97bf34',
  supportAnswers: '2efc49de65f93db27f7bd21379730fbc',
  supportArticleFeedbacks: '819a358adc405ea830be40afa6038916',
  supportArticles: '8641761927bc027525633f0516733fa1',
  supportCategories: '23edde1b5710bdd2d8e56861454681b1',
  supportCategoryArticles: '9ec47a89291a7ea08fe43af309951be8',
  supportChat: 'e7076c15199c5f1c19954bcf81c99960',
  supportFeedbackIsAllowed: 'ec1a2ab220bf6ae718f3c31e2e96466b',
  supportFeedback: '0c8652b987faa5ed17604f4ade25657d',
  supportIssueCategories: 'b8069f2cab28ff8cd7403a748d7d7ace',
  supportIssueCategoryArticles: '72c79e342767c9386709189bd4643351',
  supportSuggestedArticles: 'f43595379d7bfb3a23520b8a7bac6e42',
  supportTags: '6baaa1a8b63da4a2067d250329b4383b',
  supportViewDetails: 'c5a5ca9a8ae50735eeaaa8c04104bbeb',
  swiftIdApplicant: '222fa47edbe978321ca0f919c5e0e1da',
  swiftIdApplicationStatus: '64d472b41dc7a59255aa2a35b724a6aa',
  swiftIdApplicationSubmit: '7480517157b34e206afb0ad3dbfdf9bd',
  swiftIdApplication: 'c28ddade45b7bdd22dba81c3c6eb692b',
  swiftIdEnum: 'b6639b8f5f46cb6d9c9a5634e0bf8f85',
  swiftIdInvitation: 'ac551750f016b131050fbf84999979a1',
  swiftIdVerifySubmission: '6f4b47d5d7b6fdcffc0e8574cd480439',
  tags: 'bcf4ea4b24fd7c420e375e6a3e865817',
  taskGroupMembers: '892902b8b45557eb39bc50e6c4d09079',
  taskGroupSection: '4f685d834c91aa4b2eebe5403d1287f6',
  taskGroup: '271f3eb3faaaf1da2a4df73f58a8c333',
  tasks: '7282fe9f544b44f575a2a5e1c44e03d9',
  taxOptOutOptions: 'bb90d8285d2f8c35019d06ba12a192b0',
  taxStatement: '9e2ea0d97d15d2022fe1ad0f20a81b4b',
  tax: '269061e1c3f348f62dbd36fd55f74e0f',
  teamInvitations: 'e5f12a8e06582e4a05b1d13fd5310717',
  teamMembers: '72012171395c87039424bc159d92f2e3',
  teams: '7fb269056325fb6d64b2a7ebe207fbad',
  threadProjects: 'f1ace63b2ed02747578fb5b85eb7df94',
  threads: '120caa646814f9f54d979daeed0a34ef',
  timeTrackingDailyAggregates: 'cf0b1a2d3b1818f710fd8b075d328e75',
  timeTrackingPunches: '9ff76aece40ce374f50010c58e10c17e',
  timeTrackingSession: '80a6c6bc3554ed72d60b21f37512b918',
  timelines: '0743398a42340605ee78aec6f5360da7',
  timezones: '97c596c8284c5af2de6d9b0d718b34a7',
  toastNotifications: '1f3f0ec482c20f394b16aea711c6b5bc',
  topSkills: '88edbb1b65d6031c7e16fea85f5e9c86',
  trackingConsentMode: '273bc4a4b361de420b536425b9493c25',
  tracks: 'e432997983ba0bedffd22d84f0d1e939',
  transactionHistoryDetails: '2c9bcefdc7a6d4094ed734f28c4ca093',
  transactionHistoryItems: '584221b11640fef828f038a3bcd4d357',
  twoFactorDetails: 'bf5a516c4382437117e334903aaeae3c',
  unconfirmedAwards: '43d84cabe984ae6717efa8218ad6d763',
  universities: '6864ec0a4d30b810ff1df4e3433ea339',
  usStates: 'f251a17954a572d64b9400e2e94b9ded',
  userAvailabilities: '1765e4108fecac9a3cbf7d846f987e05',
  userBalances: '19562fd91f748c6097966018189e5985',
  userBidLimit: '02e82788a8467ff18539b987ac7227b6',
  userBidOnRussianProjects: 'f799113d4a5ebf40db8efef7a9499eab',
  userCalifornianStatuses: '811b21828faa5a88aee50fa30d9cfc63',
  userCartRequiresEmailVerification: '534e302467ed4d41b65310827efccd12',
  userCollaborations: '578395d5df1deaa1b15a9f8cb1b09df2',
  userConsent: '1e357f44b5462cc8afa2cdc613820fb2',
  userContestCollaborationWhitelist: '507680d8d3c0c2ea30ea86cb99166a55',
  userCustomEmails: '247c86a075d5ac5709031cafd4a84026',
  userDepositMethods: '874e93c5b6250f9a51ae6ac39e78cfe2',
  userDocumentSubmissions: '97cedc32f5ecee6a95749058a9792fd2',
  userEmailRequest: '86011c5edfba0d2ee6d1c29ec86d7c01',
  userEnterprises: '1cc08fb4667b5ab1271bb25872c03af1',
  userFees: '751f94139807c7463a2de341ccd3c4bc',
  userGiveGetDetails: 'f0ab8506bcbdd472a808f737b969dff6',
  userHasDuplicateIp: '3f2340a4213ed9be96b40660bfc2bad2',
  userHasGivenFeedback: '9da27991064a86ae00666fdfb61bf052',
  userInfo: 'e8ae1bc08955551eae05a678f013f768',
  userInsignias: 'e393f744166ee2426b598923634c9f7e',
  userInteractions: 'b69a5eaa43726f0eae83d0348f44abf6',
  userIpLocation: '75e3f8f983041d7582cb0cc4f81dc986',
  userLastOnline: 'bdd8436d650e5dbd3b19e46a596afab3',
  userNotificationPreferences: '0bf8997c3b3cdc7cdc4e743b76eadcb5',
  userNps: '7c0bc47c1bf75118e0643f05b38ac794',
  userParsedResumes: '432d95a91ea92debd3784e91a11a2b96',
  userPaymentControls: 'd4c613748f8b6fef5513faf94501bf5f',
  userPendingFunds: 'af370a4b7c2adb028a666297aa9ffa28',
  userPhoneVerificationBackoff: 'e1f3b584ec2dccae08f694e648be3f62',
  userQualityDetails: '0dcc0040a73b7995229e380b160abcd6',
  userRecentProjectsAndContests: 'ea394addcb61da312db4ff899767f57d',
  userRequiresEmailVerification: 'e2f0beae240a0912172c652af0c3eb4e',
  userRequiresGdpr: '1f1923492a3b9ecbd2ce5b3c9c9d1b28',
  userRequiresPaymentVerification: '2c3c2819f099d4c23433dd0a56355caf',
  userRequiresPhoneVerification: '2ce7a52a3a029abb98242e9b00337ddb',
  userResumes: '1a461d39770bc29217ae80edd63736af',
  userSettings: '3b8262f0ec3b87388dec535fa99d041f',
  userSkills: 'e25b853ca911f12c0be653aa7a70b706',
  userTaxInfo: '32b358afa6b40486fba549552b90e18d',
  userTaxOptOutReasons: 'fd226fff0b1786757716c995bba0fdfd',
  userTypeInfo: '946dad862050d0198174c3380eb7e91f',
  userVerificationProcesses: '6ce7575d4f8640b262f67c91932e3e69',
  usersFollow: 'bbea0e01511c4dca66ded193ee07fca0',
  usersLocation: '0a18f995dc28224bee7ba5812efdb48a',
  usersMfa: '6a39c996b736babac9262c3e7f5e7104',
  usersProfileImage: 'e97d332d6bb3ee806476de0483c34df7',
  usersProfile: 'f921b371154b93aaf8514fa2062ae3ad',
  usersRecommend: '0a80e5d13a75c26e4e765d9042d3acb6',
  usersSelf: '500837d407500f64c48170213b0b108f',
  usersTeamProfile: 'f921b371154b93aaf8514fa2062ae3ad',
  users: 'd21483c0c9dbd8675f4bf4a8eaba11fa',
  verificationAddressDocumentTypes: 'd13b03dc042b753ecea9437010ac4ff8',
  verificationCorporateKyc: 'd83e1fa9456cb47ce552a050de1e924c',
  verificationFiles: '95b77192f8e35b2ccc158a8d494b723d',
  verificationIdTypes: '70151aa0c0c75979b269082909b8bf3f',
  verificationProcessTypes: '2c775d17e3c24746c1f1cac290962d7a',
  verificationRequest: 'dc622d40af59fc16c53fc5dddc7a51a6',
  videoVerificationRequest: '3b556aa9cf434dea06b9bad37da7ab83',
  videochats: 'cde01ec87fec86a18199b7b2b4fa5c14',
  violationReports: '6b53c0dc4089de4a1038f520787282e0',
  webhooks: 'cada0b9dbf7f2dedb9f053882b7d0f87',
};
